import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Select } from './ui/Select';
import { motion } from 'framer-motion';
export function LeadForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      // Analytics event would fire here: group_inquiry_submitted
      console.log('Analytics: group_inquiry_submitted');
    }, 1500);
  };
  if (isSuccess) {
    return <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="bg-white p-8 rounded-xl shadow-xl border-t-4 border-gold text-center" data-id="element-177">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-178">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-179">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-180" />
          </svg>
        </div>
        <h3 className="text-2xl font-serif font-bold text-primary mb-2" data-id="element-181">
          Request Received!
        </h3>
        <p className="text-gray-600 mb-6" data-id="element-182">
          Thank you for your interest. One of our group travel specialists will
          contact you within 1 business day to discuss your trip options.
        </p>
        <Button onClick={() => setIsSuccess(false)} variant="outline" data-id="element-183">
          Send Another Request
        </Button>
      </motion.div>;
  }
  return <div id="lead-form" className="bg-white p-6 md:p-8 rounded-xl shadow-xl border-t-4 border-gold relative z-10" data-id="element-184">
      <h3 className="text-2xl font-serif font-bold text-primary mb-6" data-id="element-185">
        Tell us your group — we'll send options
      </h3>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-186">
        <Input label="Full Name" placeholder="e.g. Sarah Johnson" required data-id="element-187" />

        <Select label="Organization Type" placeholder="Select your group type..." required options={[{
        value: 'faith',
        label: 'Faith Community / Church'
      }, {
        value: 'alumni',
        label: 'Alumni Association'
      }, {
        value: 'senior',
        label: 'Senior Center / Active Adults'
      }, {
        value: 'club',
        label: 'Club / Social Organization'
      }, {
        value: 'corporate',
        label: 'Corporate / Incentive'
      }, {
        value: 'other',
        label: 'Other'
      }]} data-id="element-188" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-189">
          <Input label="Email Address" type="email" placeholder="name@organization.org" required data-id="element-190" />
          <Input label="Phone Number" type="tel" placeholder="(555) 123-4567" required data-id="element-191" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-192">
          <Select label="Est. Group Size" placeholder="Select size..." required options={[{
          value: '10-20',
          label: '10-20 Travelers'
        }, {
          value: '20-30',
          label: '20-30 Travelers'
        }, {
          value: '30-40',
          label: '30-40 Travelers'
        }, {
          value: '40-50',
          label: '40-50 Travelers'
        }, {
          value: '50+',
          label: '50+ Travelers'
        }]} data-id="element-193" />
          <Select label="Travel Season" placeholder="When to travel?" required options={[{
          value: 'spring2026',
          label: 'Spring 2026'
        }, {
          value: 'summer2026',
          label: 'Summer 2026'
        }, {
          value: 'fall2026',
          label: 'Fall 2026'
        }, {
          value: 'winter2026',
          label: 'Winter 2026-27'
        }, {
          value: 'flexible',
          label: 'Flexible Dates'
        }]} data-id="element-194" />
        </div>

        <Select label="Destination Interest" placeholder="Where would you like to go?" required options={[{
        value: 'europe',
        label: 'Europe'
      }, {
        value: 'river',
        label: 'River Cruises'
      }, {
        value: 'usa',
        label: 'USA & Canada'
      }, {
        value: 'holy',
        label: 'Holy Land / Faith Travel'
      }, {
        value: 'exotic',
        label: 'Exotic / International'
      }, {
        value: 'unsure',
        label: 'Not sure yet - Need ideas'
      }]} data-id="element-195" />

        <div className="pt-2" data-id="element-196">
          <Button type="submit" fullWidth size="lg" disabled={isSubmitting} className="shadow-md hover:shadow-lg transform transition-all" data-id="element-197">
            {isSubmitting ? 'Sending...' : 'Get My Group Options'}
          </Button>

          <p className="text-center text-xs text-gray-500 mt-3" data-id="element-198">
            No obligation. We'll contact you within 1 business day.
            <br data-id="element-199" />
            <span className="opacity-75" data-id="element-200">
              We only use this info to help plan your trip.
            </span>
          </p>
        </div>
      </form>
    </div>;
}